import { render } from "./KehamilanSekarang.vue?vue&type=template&id=6cfd5fc5"
import script from "./KehamilanSekarang.vue?vue&type=script&lang=js"
export * from "./KehamilanSekarang.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__